module.exports = __webpack_public_path__ + "static/img/bg_image.e28ea79d.png";